import React from 'react';
import { Music4Icon } from 'lucide-react';
import { primaryVolumes, secondaryVolumes, Volume } from '../data/content';
type VolumeGroupProps = {
  title: string;
  subtitle: string;
  volumes: Volume[];
};
function VolumeGroup({
  title,
  subtitle,
  volumes
}: VolumeGroupProps) {
  return <div data-id="element-227" data-mp="pv2kock0htaq">
      <div className="flex items-baseline gap-3 border-b border-foreground/10 pb-4" data-id="element-228" data-mp="put1p8xdwmej">
        <h3 className="font-display text-xl font-black tracking-tight text-foreground" data-id="element-229" data-mp="b6oje628ucwa">
          {title}
        </h3>
        <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-success" data-id="element-230" data-mp="fxen7ev0u7ov">
          {subtitle}
        </span>
      </div>
      <ul className="mt-6 space-y-3" data-id="element-231" data-mp="27kyqxnfhpfo">
        {volumes.map(volume => <li key={volume.number} className="relative flex items-start gap-4 overflow-hidden rounded-2xl bg-background py-4 pl-6 pr-5" data-id="element-232" data-mp="75w5v0mc9lu7">
            <span aria-hidden="true" className="absolute inset-y-0 left-0 w-1.5" style={{
          backgroundColor: volume.accent
        }} data-id="element-233" data-mp="3tckpsc8egm7g" />
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full font-display text-sm font-bold text-surface" style={{
          backgroundColor: volume.accent
        }} data-id="element-234" data-mp="37utdqdk9qtfu">
              {volume.number}
            </span>
            <div data-id="element-235" data-mp="3htsaaxrreymh">
              <div className="flex flex-wrap items-baseline gap-x-2" data-id="element-236" data-mp="3hr66n97zp39j">
                <h4 className="font-display text-base font-bold text-foreground" data-id="element-237" data-mp="2u3xxuhbcrc2r">
                  {volume.title}
                </h4>
                <span className="text-[10px] font-bold uppercase tracking-[0.12em] text-foreground/40" data-id="element-238" data-mp="32vq56j52y534">
                  {volume.level}
                </span>
              </div>
              <p className="mt-1 text-xs leading-relaxed text-foreground/55" data-id="element-239" data-mp="2y2x17xhfr0s3">
                {volume.text}
              </p>
            </div>
          </li>)}
      </ul>
    </div>;
}
export function WhatsInside() {
  return <section id="contenuto" className="w-full bg-surface px-5 py-20 sm:py-28" data-id="element-240" data-mp="9dr3v82plexa">
      <div className="mx-auto max-w-4xl" data-id="element-241" data-mp="ecaqzbt1gwr8">
        <div className="text-center" data-id="element-242" data-mp="eb948a2nulto">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-success" data-id="element-243" data-mp="ea7p9uiixf6o">
            9 volumes numériques · PDF haute résolution
          </span>
          <h2 className="mt-4 font-display text-[1.9rem] font-black leading-tight tracking-tight text-foreground sm:text-[2.6rem]" data-id="element-244" data-mp="o0sn3fqdifoj">
            <Music4Icon className="mr-2 inline-block h-[0.8em] w-[0.8em] -translate-y-0.5 text-emphasis" aria-hidden="true" data-id="element-245" data-mp="3mlu8cxelhgdz" />
            Que contient le pack{' '}
            <span className="italic text-emphasis" data-id="element-246" data-mp="evxnvzo04tz">Musique Prête™&nbsp;?</span>
          </h2>
        </div>

        <div className="mt-12 grid gap-10 md:grid-cols-2" data-id="element-247" data-mp="599nzjzgzlrs">
          <VolumeGroup title="École Primaire" subtitle="5 volumes" volumes={primaryVolumes} data-id="element-248" data-mp="1bqwsnsn4gpi6" />
          <VolumeGroup title="Collège" subtitle="4 volumes" volumes={secondaryVolumes} data-id="element-249" data-mp="318ty0k6fb64t" />
        </div>
      </div>
    </section>;
}